module.exports = __webpack_public_path__ + "media/images/ico-share-no-673b0f04.svg";